<template>
  <div>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>دسته بندی:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select
            :items="keys"
            item-text="Text"
            item-value="Value"
            v-model="filter"
            no-data-text="داده ای برای نمایش وجود ندارد."
          ></v-select>
        </v-col>
      </v-row>
      <br />
      <div v-if="filterInfo.length > 0">
        <div
          v-for="item in filterInfo"
          :key="item.Fserial_KMaharat"
          class="container"
        >
          <v-card-title class="info-detail">
            <b style="width: 60%"> {{ item.Title }} </b>
            <div
              style="width: 40%; text-align: left"
              v-if="item.adminConfirm == '0'"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="cardBtn"
                    v-bind="attrs"
                    v-on="on"
                    fab
                    small
                    depressed
                    @click="showAddDialog(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>ویرایش</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="cardBtn"
                    v-bind="attrs"
                    v-on="on"
                    fab
                    small
                    depressed
                    @click="removeRequest(item.FSerial_StudentMaharat)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>حذف</span>
              </v-tooltip>
            </div>
          </v-card-title>

          <div class="contain">
            <v-row v-if="item.WithComment" align="center">
              <v-col class="d-flex" cols="4" sm="2">
                <b>توضیحات:</b>
              </v-col>
              <v-col class="d-flex" cols="8" sm="10">
                {{ item.Comment != "" ? item.Comment : "----" }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex" cols="4" sm="2">
                <b>مدرک:</b>
              </v-col>

              <v-col class="d-flex" cols="8" sm="10">
                {{ item.Madrak ? "دارم" : "ندارم" }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex" cols="4" sm="2">
                <b>سال اخذ:</b>
              </v-col>

              <v-col class="d-flex" cols="8" sm="2">
                {{ item.Madrak_Sal != "" ? item.Madrak_Sal : "----" }}
              </v-col>
              <v-col class="d-flex" cols="4" sm="3">
                <b>صادركننده مدرك:</b>
              </v-col>
              <v-col class="d-flex" cols="8" sm="5">
                {{
                  item.Madrak_Saderkonandeh != ""
                    ? item.Madrak_Saderkonandeh
                    : "----"
                }}
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <div>
        <v-btn
          class="addBtn"
          color="primary white--text"
          fab
          @click="showAddDialog(null)"
        >
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </div>
    </v-card>
    <app-add-dialog
      :show="showAdd"
      :data="maharat"
      :selectableMaharats="selectableMaharats"
      @saveMaharat="saveMaharatHandler"
    ></app-add-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog";
import AddMaharat from "./AddMaharat";
export default {
  data() {
    return { filter: "0", activeInfo: [], maharat: {}, showAdd: false };
  },
  props: ["keys", "info"],
  components: {
    appDialog: Dialog,
    appAddDialog: AddMaharat,
  },

  computed: {
    filterInfo() {
      let actives = this.activeInfo.filter((single) => {
        return single.Selected || single.FSerial_StudentMaharat != "";
      });
      if (this.filter == "0") {
        return actives;
      } else {
        return actives.filter((single) => {
          return single.Serial_Category == this.filter;
        });
      }
    },
    selectableMaharats() {
      let result = [];
      for (let i = 0; i < this.activeInfo.length; i++) {
        const maharat = this.activeInfo[i];
        if (!maharat.Selected && maharat.FSerial_StudentMaharat == "") {
          if (this.filter == "0" || maharat.Serial_Category == this.filter) {
            result.push({
              Value: maharat.Fserial_KMaharat,
              Text: maharat.Title,
            });
          }
        }
      }
      return result;
    },
  },
  methods: {
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این مهارت هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        this.$emit("removeMaharat", index);
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    /**
     * call remove api if user click on yes
     */
    showAddDialog(info) {
      if (info == null) {
        info = {
          Comment: "",
          Fserial_KMaharat: "",
          Madrak: false,
          Madrak_Saderkonandeh: "",
          Madrak_Sal: "",
          FSerial_StudentMaharat: "",
        };
      }
      this.maharat = info;
      this.showAdd = true;
    },
    saveMaharatHandler(info) {
      if (info != null) this.$emit("saveMaharat", info);
      this.showAdd = false;
    },
  },
  watch: {
    info(newvalue) {
      this.activeInfo = newvalue;
    },
  },
};
</script>
<style scoped>
.form {
  display: flow-root;
}
.contain {
  padding: 15px 20px;
  border-radius: 15px !important;
}

.v-card__title {
  border-radius: unset !important;
  margin: 0px !important;
}
.cardBtn {
  background-color: transparent !important;
}

</style>
